import {Record, List} from 'immutable';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';
import Image from 'web-app/react/entities/common/image';

class Organization extends Record<{
    organizationId: string;
    createdAt?: string;
    title: string;
    image: typeof Image.record | null;
    institutionIds: List<string>;
    roleIds: List<string>;
    areaIds: List<string>;
    fetching: boolean;
    behaviors: BehaviorsCollection;
    timezone: string;
    country: string;
}>({
    organizationId: '',
    createdAt: undefined,
    title: '',
    image: null,
    institutionIds: List(),
    roleIds: List(),
    areaIds: List(),
    fetching: false,
    behaviors: new BehaviorsCollection([]),
    timezone: '',
    country: '',
}) {}

const fetchingDummy = new Organization().merge({
    fetching: true,
});

function fromAPI(data: any) {
    const {behaviors, image, institutions, ...rest} = data;

    return new Organization({
        behaviors: new BehaviorsCollection(behaviors),
        image: Image.fromAPI(image),
        institutionIds: List(institutions).map((i: any) => i.institutionId),
        ...rest,
    });
}

export default {
    record: Organization,
    default: new Organization(),
    fetchingDummy,
    fromAPI,
};
